<template>
<div>
    <div class="row" style="margin-bottom: 7px;">
        <div class="col-xs-12">
            <label for="resource-comment">{{ $_locale('comment') }}</label>
            <textarea 
                name="resource-comment" 
                class="form-control"
                v-model="editComment.comment">
            </textarea>
        </div>
    </div>
    <div class="row">
        <div class="col-xs-4">
            <label for="">{{ $_locale('valid from') }}</label>
            <input type="time" v-model="editComment.validFrom" class="form-control" />
        </div>
        <div class="col-xs-4">
            <label for="">{{ $_locale('valid to') }}</label>
            <input type="time" v-model="editComment.validTo" class="form-control" />
        </div>
        <div class="col-xs-4">
            <label for="">{{ $_locale('public') }}</label>
            <select class="form-control"
                v-model="editComment.publicComment">
                <option :value="true">{{ $_locale('yes') }}</option>
                <option :value="false">{{ $_locale('no') }}</option>
            </select>
        </div>
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: {
        resource: {
            type: Object,
            required: false,
            default: () => ({})
        }
    }, 
    data: () => ({
        view: 'list',
        editComment: {
            comment: '',
            commentId: null,
            validFrom: null,
            validTo: null,
            baseDate: null,
            publicComment: false,
        }
    }),
    computed: {
        ...mapGetters({
            selectedDate: 'reservations/date',
        }),
    },
    methods: {
        isEdit() {
            return !!this.editComment.commentId;
        },
        setDateStartTime(start, minutes) {
            const dateTimeStart = moment(start);
            const dateTimeEnd = dateTimeStart.clone().add(minutes, 'minutes');
            
            this.editComment.validFrom = dateTimeStart.format('HH:mm');
            this.editComment.validTo = dateTimeEnd.format('HH:mm');
            this.editComment.baseDate = moment(start).format('YYYY-MM-DD');
        },
        init(comment = null) {
            if (comment === null) {
                const dateTimeStart = moment().startOf('hour');
                const dateTimeEnd = dateTimeStart.clone().add(1, 'hour');

                this.editComment.comment = '';
                this.editComment.publicComment = false;
                this.editComment.validFrom = dateTimeStart.format('HH:mm');
                this.editComment.validTo = dateTimeEnd.format('HH:mm');
                this.editComment.baseDate = moment(this.selectedDate).format('YYYY-MM-DD');
            } else {
                this.editComment.commentId = comment.commentId;
                this.editComment.comment = comment.comment;
                this.editComment.publicComment = comment.public ? true : false;
                this.editComment.validFrom = moment(comment.dateTimeStart).format('HH:mm');
                this.editComment.validTo = moment(comment.dateTimeEnd).format('HH:mm');
                this.editComment.baseDate = moment(comment.dateTimeStart).format('YYYY-MM-DD');
            }
        },
        saveComment() {
            const comment = this.editComment.comment || '';
            
            return this.pushComment({
                resourceId: this.resource.resourceId,
                commentId: this.editComment.commentId,
                comment: comment.trim(),
                dateTimeStart: `${ this.editComment.baseDate } ${ this.editComment.validFrom }:00`,
                dateTimeEnd: `${ this.editComment.baseDate } ${ this.editComment.validTo }:00`,
                public: this.editComment.publicComment,
                deleted: false,
            });
        },
        deleteComment() {
            const comment = { ...this.editComment };

            return this.$store.dispatch('reservations/deleteResourceComment', comment)
                .then(response => {
                    const { data } = response;

                    if (data.success) {
                        this.$emit('success', { type: 'delete' })
                    }

                    return response;
                })
        },
        pushComment(comment) {
            return this.$store.dispatch('reservations/addResourceComment', comment)
                .then(response => {
                    const { data } = response;

                    if (data.success) {
                        this.$emit('success', { type: 'push' })
                    }

                    return response;
                })
        },
    },
    mounted() {
        this.init();
    }
}
</script>